import '../../styles/buttonFiltered.css';

const FilteredButtons = ({ items, selectedValue, setSelected }) => (
    <div className="btn_filter">
        {items.map((item, index) =>
            <button
                key={index}
                onClick={() => setSelected(item.value)}
                className={item.value === selectedValue ? "btn_event_selected" : "btn_event"}
            >
                {item.label}
            </button>
        )}

    </div>
);

export default FilteredButtons;